import awProfile from "../../images/MeetCrew/ArielleWeston.svg";
import mmProfile from "../../images/MeetCrew/MichaelMeyer.svg";
import ckProfile from "../../images/MeetCrew/ChadKeller.svg";
import dfProfile from "../../images/MeetCrew/DavidFoote.svg";
import jwProfile from "../../images/MeetCrew/JonahWeston.svg";
import tsProfile from "../../images/MeetCrew/TaniSanchez.svg";
import lsProfile from "../../images/MeetCrew/LukeSchmidt.svg";
import gfProfile from "../../images/MeetCrew/GarethFoote.svg";
import smProfile from "../../images/MeetCrew/ShawnMcKee.svg";
// import bhProfile from "../../images/MeetCrew/BethanyHernandez.svg";
// import bHiProfile from "../../images/MeetCrew/BrianHill.svg";
// import krProfile from "../../images/MeetCrew/KyleRoehrs.svg";
// import jtProfile from "../../images/MeetCrew/JessTaylor.svg";
// import msProfile from "../../images/MeetCrew/MelissaStayton.svg";
// import ehProfile from "../../images/MeetCrew/EstevanHernandez.svg";
// import gsProfile from "../../images/MeetCrew/GrantSimmons.svg";

export const MeetCrewData = [
  {
    name: "Arielle",
    title: "VP of Client Development",
    linkedIn: "https://www.linkedin.com/in/arielle-carr-agilepm/",
    profileImg: awProfile,
    blurb: "Arielle leads our project management and design disciplines. She believes great work starts with empathy for the user and the team, and that excellent project managers create the circumstances for each team member to do their best work. Outside of work, she loves spending time with her family, cooking (and eating) delicious food, creating wheel-thrown functional ceramics, hiking, and paddleboarding.",
  },
  {
    name: "Chad",
    title: "Senior Software Engineer",
    linkedIn: "https://www.linkedin.com/in/chad-keller-74a4322/",
    profileImg: ckProfile,
    blurb: "As a senior engineer, Chad’s technical leadership fosters the growth of every team member. Some fun facts about him: His favorite movie is So I Married an Axe Murderer. He loves to travel and has visited over 30 different countries. He is particularly fond of pina coladas, and getting caught in the rain."
  },
  {
    name: "David", 
    title: "CEO & CTO",
    linkedIn:
      "https://www.linkedin.com/in/bluerocketcto/",
    profileImg: dfProfile,
    blurb: "With more than 25 years of experience in the software industry, David has led digital transformation at many large companies, and is especially interested in how people learn and grow in their chosen profession. He is currently writing a book on the evolution of project management. On the weekends he likes to work on the family farm, and his favorite meals are Tacos and Sushi.",
  },
    {
    name: "Gareth",
    title: "Quality Assurance",
    linkedIn: "https://www.linkedin.com/in/gareth-foote-47532035b/",
    profileImg: gfProfile,
    blurb: "Gareth has been a great support for the QA team, contributing to product testing and feedback. Outside of work, his biggest passions are snowboarding and competitive video games. He has chased fresh powder in Tahoe and Hakuba, two of his favorite places for both the slopes and the food.",
  },
  {
    name: "Jonah",
    title: "Senior Developer",
    linkedIn:
      "https://www.linkedin.com/in/jonah-weston-a6289a185/",
    profileImg: jwProfile,
    blurb: "A versatile engineer, Jonah started in Quality Assurance and now excels as a developer with expert problem solving ability. He enjoys strategy board games. His favorite movie is Star Wars: Empire Strikes Back. He is fully fluent in StackOverflow and Google.",
  },
  {
    name: "Luke",
    title: "Quality Assurance & Junior Developer",
    linkedIn:
      "https://www.linkedin.com/in/luke-schmidt-720a551b8/",
    profileImg: lsProfile,
    blurb: "Another newcomer is Luke, a talented and very detail oriented Quality Assurance Engineer and Junior Web Developer who shows a great passion for learning. His hobbies include: hiking, biking, traveling, PC gaming, and reading. His favorite movie is Interstellar. (Good choice, Luke.)",
  },
  {
    name: "Michael",
    title: "CFO",
    linkedIn:
      "https://www.linkedin.com/in/michaelmeyer50/",
    profileImg: mmProfile,
    blurb: "Michael keeps the finances in order for Blue Rocket. Some fun facts about him: He loves science fiction and fantasy. He also is a soccer fan. He has lived and worked in Canada, Australia, and Korea and is now going to help his family start a craft brewery and a farm in Kentucky.",
  },
  {
    name: "Shawn",
    title: "Lead App Engineer & Architect",
    linkedIn: "https://www.linkedin.com/in/shawn-mckee-63367b3/",
    profileImg: smProfile,
    blurb: "Ever since the iOS SDK came out in 2008, Shawn has been developing apps for mobile, web, and desktop devices with a hyper-focus on building quality user experiences. He loves collaborating with product, design, and back-end teams to create the best experiences possible, using the best technologies available. In the evenings, he unwinds with some old 8-bit retro. (Favorites include Ms. Pac-Man, M.U.L.E., and Zork.)",
  },
  {
    name: "Tani",
    title: "Senior Developer & Designer",
    linkedIn:
      "https://www.linkedin.com/in/tani-sanchez-b8b48660/",
    profileImg: tsProfile,
    blurb: "Tani started off in Quality Assurance before making her way into Development and Design. She loves to learn and acquire new skills. Her hobbies include: guitar, singing, art, reading, writing, and podcasting with her sister. Before joining the team she was a photographer and video editor, and still does the occasional photo shoot. She is also on teams Interstellar and Dune.",
  },
];
